import React from "react";

type ProgressTextBarProps = {
  value: number;
  totalBlocks?: number;
};

const ProgressTextBar: React.FC<ProgressTextBarProps> = ({
  value,
  totalBlocks = 10,
}) => {
  const safeValue = Math.max(0, Math.min(100, Math.round(value)));
  const filledBlocks = Math.round((safeValue / 100) * totalBlocks);
  const emptyBlocks = totalBlocks - filledBlocks;
  const bar = `${"#".repeat(filledBlocks)}${"-".repeat(emptyBlocks)}`;

  return (
    <span className="progress-text-bar" aria-label={`${safeValue}% complete`}>
      [{bar}] {safeValue}%
    </span>
  );
};

export default ProgressTextBar;
